/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Appointment } from './Appointment';
import {
    AppointmentFromJSON,
    AppointmentFromJSONTyped,
    AppointmentToJSON,
} from './Appointment';

/**
 * 
 * @export
 * @interface FillDocumentTemplateParams
 */
export interface FillDocumentTemplateParams {
    /**
     * 
     * @type {Appointment}
     * @memberof FillDocumentTemplateParams
     */
    appointment?: Appointment;
    /**
     * 
     * @type {string}
     * @memberof FillDocumentTemplateParams
     */
    patient_id: string;
    /**
     * 
     * @type {string}
     * @memberof FillDocumentTemplateParams
     */
    appointment_note: string;
    /**
     * 
     * @type {string}
     * @memberof FillDocumentTemplateParams
     */
    extra_instructions?: string;
}

/**
 * Check if a given object implements the FillDocumentTemplateParams interface.
 */
export function instanceOfFillDocumentTemplateParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;
    isInstance = isInstance && "appointment_note" in value;

    return isInstance;
}

export function FillDocumentTemplateParamsFromJSON(json: any): FillDocumentTemplateParams {
    return FillDocumentTemplateParamsFromJSONTyped(json, false);
}

export function FillDocumentTemplateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FillDocumentTemplateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appointment': !exists(json, 'appointment') ? undefined : AppointmentFromJSON(json['appointment']),
        'patient_id': json['patient_id'],
        'appointment_note': json['appointment_note'],
        'extra_instructions': !exists(json, 'extra_instructions') ? undefined : json['extra_instructions'],
    };
}

export function FillDocumentTemplateParamsToJSON(value?: FillDocumentTemplateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appointment': AppointmentToJSON(value.appointment),
        'patient_id': value.patient_id,
        'appointment_note': value.appointment_note,
        'extra_instructions': value.extra_instructions,
    };
}

